export default {"breakpoint":{"thresholds":{"sm":768,"md":1025},"scrollBarWidth":0},"theme":{"themes":{"light":{"darkRed":"#C2111D"}}}}
